/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ToggleOnSolidV6 = (props) => (
  <Icon {...props} name="Toggle On Solid V6">
    <path d="M10.667 2.667A5.319 5.319 0 0 1 16 8a5.335 5.335 0 0 1-5.333 5.333H5.334A5.333 5.333 0 0 1 .001 8a5.318 5.318 0 0 1 5.333-5.333h5.333zm0 8A2.668 2.668 0 0 0 13.334 8a2.652 2.652 0 0 0-2.667-2.667A2.636 2.636 0 0 0 8 8a2.652 2.652 0 0 0 2.667 2.667z" />
  </Icon>
);

export default ToggleOnSolidV6;
